import React from 'react';
import Navbar from "./Navbar";
import Footer from "./Footer";


const Privacy = () => {
    return (
        <>
            <Navbar />
            <div className="min-h-screen bg-white py-24">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="text-4xl font-extrabold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent mb-8">
                        Privacy Policy
                    </h1>

                    <div className="prose prose-blue max-w-none">
                        <p className="text-lg text-gray-600 mb-6">
                            Last updated: March 20, 2024
                        </p>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Introduction</h2>
                            <p className="text-gray-600">
                                At RemoveBackground.online, we take your privacy seriously. This Privacy Policy explains how we collect, use,
                                and protect your personal information when you use our service.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Information We Don't Collect</h2>
                            <p className="text-gray-600">
                                Our service processes all images locally in your browser. We do not upload, store, or transmit your images
                                to any servers. Your images remain completely private and secure on your device.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Technical Data Collection</h2>
                            <p className="text-gray-600">
                                We may collect anonymous usage statistics to improve our service, including:
                            </p>
                            <ul className="list-disc pl-6 mt-4 text-gray-600">
                                <li>Browser type and version</li>
                                <li>Device type and operating system</li>
                                <li>Performance metrics</li>
                                <li>Feature usage patterns</li>
                            </ul>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Cookies</h2>
                            <p className="text-gray-600">
                                We use essential cookies to ensure the basic functionality of our website. These cookies do not track
                                personal information and are strictly necessary for the website to function properly.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Third-Party Services</h2>
                            <p className="text-gray-600">
                                We may use third-party analytics services to help us understand how our service is being used. These
                                services may collect anonymous usage data but do not have access to your images or personal information.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Changes to This Policy</h2>
                            <p className="text-gray-600">
                                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new
                                Privacy Policy on this page and updating the "Last updated" date.
                            </p>
                        </section>

                        <section className="mb-8">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
                            <p className="text-gray-600">
                                If you have any questions about this Privacy Policy, please contact us at:{' '}
                                <a href="mailto:privacy@removebackground.online" className="text-blue-600 hover:text-blue-500">
                                    privacy@removebackground.online
                                </a>
                            </p>
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Privacy;